import { render, staticRenderFns } from "./statisticsIcons.vue?vue&type=template&id=22ed0350&scoped=true&lang=html&"
import script from "./statisticsIcons.vue?vue&type=script&lang=js&"
export * from "./statisticsIcons.vue?vue&type=script&lang=js&"
import style0 from "./statisticsIcons.vue?vue&type=style&index=0&id=22ed0350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed0350",
  null
  
)

export default component.exports